import { reviewsLogger } from "../utils/reviews-logger";
import { useEffect, useState } from "react";

export default function useReviewsBVInjectedData() {
  const [bvInjectedData, setBvInjectedData] = useState({
    reviewEmailReferral: "",
    starRating: 0,
  });

  useEffect(() => {
    if (globalThis?.window) {
      const search = new URLSearchParams(globalThis?.window.location.search);

      if (search.has("bvinjecteddata")) {
        try {
          const injectedData = JSON.parse(search.get("bvinjecteddata"));
          const {
            review_referral: reviewEmailReferral = "",
            star_rating: starRating = 0,
          } = injectedData;
          const isValidReviewReferral = ["staff", "sweat_collective"].includes(
            reviewEmailReferral
          );

          if (isValidReviewReferral) {
            setBvInjectedData({
              reviewEmailReferral,
              starRating,
            });
          }
        } catch (error) {
          reviewsLogger({
            bazaarvoiceId: "",
            url: globalThis.window?.location.href,
            componentName: "pdp-reviews",
            functionName: "useReviewsBVInjectedData",
            message: "Error parsing write review query parms",
          });
        }
      }
    }
  }, []);

  return bvInjectedData;
}
